<template>
  <button
    type="button"
    class="button"
    :class="variant"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: 'Button',
    props: {
      variant: { type: String, default: null }
    },
    methods: {
      handleClick (e) {
        this.$emit('click', e)
      }
    },
  }
</script>

<style>
  .button {
    min-width: 160px;
    box-shadow: inset 0 0 0 1px var(--blue);
    border: 0;
    color: var(--blue);
    font-size: var(--h5);
    padding: var(--space-1) var(--space-3);
    background-color: var(--white);
    border-radius: 99px;
    cursor: pointer;
  }

  .button:focus,
  .button:active {
    box-shadow: none;
    outline: none;
  }

  .button:hover,
  .button.primary {
    background-color: var(--blue);
    color: var(--white);
  }

  .button.primary:hover,
  .button.circle:hover {
    box-shadow: inset 0 0 0 99em rgba(0,0,0,.1);
  }

  .button:disabled,
  .button:disabled:hover,
  .button.primary:disabled:hover {
    box-shadow: none;
    background-color: var(--gray);
    color: var(--gray-3);
    cursor: default;
  }

  .button.circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    min-width: initial;
    background-color: var(--white);
    box-shadow: none;
  }

  .button.circle.red {
    background-color: var(--red);
  }

  .button.circle.dark-blue {
    background-color: var(--dark-blue);
  }

  .button.icon {
    min-width: initial;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;
  }

  .button.icon:hover {
    opacity: .75;
  }

  .button.link {
    min-width: initial;
    box-shadow: none;
    background-color: none;
    color: var(--blue);
    font-weight: 600;
    padding: 0;
    border-radius: 0;
  }
  .button.link:hover {
    background-color: transparent;
    color: var(--dark-blue);
  }
</style>
